import React, { Component } from 'react';
import propTypes from 'prop-types';

class Controls extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isPressed: false,
			duration: '0:00',
			totalDuration: '0:00',
			canvasWidth: 100,
			shouldPlay: true
		};
		this.canPlay = this.canPlay.bind(this);
		this.formatTime = this.formatTime.bind(this);
		this.updateProgress = this.updateProgress.bind(this);
		this.mouseDown = this.mouseDown.bind(this);
		this.mouseUp = this.mouseUp.bind(this);
		this.rewind = this.rewind.bind(this);
		this.getCoefficient = this.getCoefficient.bind(this);
		this.getRangeBox = this.getRangeBox.bind(this);
		this.inRange = this.inRange.bind(this);
	}

	canPlay() {
		const player = document.getElementById('audio-player-non-terminal-statuses');
		this.setState({
			totalDuration: this.formatTime(player.duration)
		});
	}

	updateProgress() {
		const player = document.getElementById('audio-player-non-terminal-statuses');
		var current = player.currentTime;
		var percent = (current / player.duration) * 100;
		this.progress.style.width = percent + '%';

		this.setState({
			duration: this.formatTime(current)
		});
	}

	formatTime(time) {
		var min = Math.floor(time / 60);
		var sec = Math.floor(time % 60);
		return min + ':' + (sec < 10 ? '0' + sec : sec);
	}

	mouseDown() {
		this.setState({
			isPressed: true,
			volume: 1
		});
	}

	mouseUp() {
		this.setState({
			isPressed: false
		});
	}

	rewind(event) {
		const player = document.getElementById('audio-player-non-terminal-statuses');
		if (this.inRange(event)) {
			player.currentTime = player.duration * this.getCoefficient(event);
		}
		this.updateProgress(event);

	}

	getCoefficient(event) {
		var slider = this.slider;
		var rect = slider.getBoundingClientRect();
		var K = 0;
		var offsetX = event.clientX - rect.left;
		var width = slider.clientWidth;
		K = offsetX / width;
		if (offsetX / width > 1) {
			K = 1;
		}
		else {
			K = offsetX / width;
		}
		return K;
	}

	inRange(event) {
		var rangeBox = this.slider;
		var rect = rangeBox.getBoundingClientRect();
		var min = rect.left;
		var max = min + rect.right;
		if (event.clientX < min || event.clientX > max) return false;
		return true;
	}

	getRangeBox(event) {
		var rangeBox = event.target;
		var el = rangeBox;
		if (event.type == 'click') {
			rangeBox = event.target.parentElement.parentElement;
		}
		if (event.type == 'mousemove') {
			rangeBox = el.parentElement.parentElement;
		}
		return rangeBox;
	}

	componentDidMount() {
		const player = document.getElementById('audio-player-non-terminal-statuses');
		player.play();
		player.addEventListener('timeupdate', this.updateProgress, false);
		player.addEventListener('canplay', () => {this.state.isPressed && this.canPlay();});
		window.addEventListener('mousemove', (event) => {this.state.isPressed && this.rewind(event);});
		window.addEventListener('mouseup', () => {this.state.isPressed && this.mouseUp();});
	}

	componentWillUnmount() {
		const player = document.getElementById('audio-player-non-terminal-statuses');
		player.pause();
		player.removeEventListener('canplay', () => {this.state.isPressed && this.canPlay();});
		player.removeEventListener('timeupdate', this.updateProgress, false);
		window.removeEventListener('mousemove', (event) => {this.state.isPressed && this.rewind(event);}, false);
		window.removeEventListener('mouseup', () => {this.state.isPressed && this.mouseUp();});
	}

	render() {
		const {width} = this.props;
		return (
			<div className="controls">
				<span className="current-time">{this.state.duration}</span>
				<div
					onClick={this.rewind}
					ref={elem => this.slider = elem}
					className="slider propgress-slider"
					id="progress-slider-audio-player"
					data-direction="horizontal"
				>
					<canvas width={`${width}`} height={`${55}`} id='showcase'></canvas>
					<div ref={elem => this.progress = elem} className="progress">
						<div onMouseDown={this.mouseDown} className="pin" id="progress-pin-audio-player"></div>
					</div>
				</div>
				<span className="total-time">{this.state.totalDuration}</span>
			</div>
		);
	}
}

Controls.propTypes = {
	width: propTypes.number.isRequired
};

export default Controls;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/player/Controls/index.js